import { ENV } from '../../environment';

type Config = {
  dsn: string;
};

const DevEnv: Config = {
  dsn: 'https://e31f9dc05f914f18bc286b05e568ac9e@o280340.ingest.sentry.io/6494316',
};

const ProdEnv: Config = {
  dsn: 'https://e31f9dc05f914f18bc286b05e568ac9e@o280340.ingest.sentry.io/6494316',
};

export const config: Config = ENV === 'development' ? DevEnv : ProdEnv;
